var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 144,
    viewBox: "0 0 232 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 144,
    fill: "url(#paint0_linear_274_1513)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 48C96 43.625 99.5 40 104 40H148C152.375 40 156 43.625 156 48V84C156 88.5 152.375 92 148 92H118C116.625 88.875 114.25 86.125 111.5 84H148V48H104V54.25C101.625 52.875 98.875 52 96 52V48ZM127.5 57.5C127 56.875 126.75 56 127.125 55.25C127.375 54.5 128.125 54 129 54H140C141 54 142 55 142 56V67C142 67.875 141.5 68.625 140.75 68.875C140 69.25 139.125 69 138.5 68.5L135.125 65.125L126.125 74.125C124.875 75.375 123 75.375 121.875 74.125L113.875 66.125C112.625 65 112.625 63.125 113.875 62C115 60.75 116.875 60.75 118.125 62L124 67.875L130.875 60.875L127.5 57.5ZM84 68C84 63.75 86.25 59.875 90 57.625C93.625 55.5 98.25 55.5 102 57.625C105.625 59.875 108 63.75 108 68C108 72.375 105.625 76.25 102 78.5C98.25 80.625 93.625 80.625 90 78.5C86.25 76.25 84 72.375 84 68ZM76 100.75C76 91.5 83.375 84 92.625 84H99.25C108.5 84 116 91.5 116 100.75C116 102.5 114.5 104 112.625 104H79.25C77.375 104 76 102.625 76 100.75Z",
    fill: "url(#paint1_linear_274_1513)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_274_1513",
    x1: 116,
    y1: 0,
    x2: 116,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_274_1513",
    x1: 116,
    y1: 40,
    x2: 116.223,
    y2: 162.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#6D5EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#4B1E8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudience);
export default __webpack_public_path__ + "static/media/Audience.b28665ab61c1975b370409e075b65a84.svg";
export { ForwardRef as ReactComponent };